module.exports = "/_next/static/images/9d6c601792030793e5323e4a0eefe122-boy-looking-to-the-front@0.75x.jpg.webp";